import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Share2, Copy, X, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { WEDDING_CONFIG, getGuestName } from "../config";

export default function ShareButton() {
  const [open, setOpen] = useState(false);
  const guestName = getGuestName();

  const buildInviteLink = (guestOverride) => {
    const base = typeof window !== "undefined"
      ? `${window.location.origin}${window.location.pathname}`
      : "";
    const guest = guestOverride !== undefined ? guestOverride : guestName;
    return guest ? `${base}?to=${encodeURIComponent(guest)}` : base;
  };

  const [guestInput, setGuestInput] = useState(guestName || "");
  const inviteLink = buildInviteLink(guestInput);

  const shareWA = () => {
    const text =
`Halo${guestInput ? " " + guestInput : ""},

Dengan hormat kami mengundang Anda ke pernikahan kami:

💍 *${WEDDING_CONFIG.groom.firstName} & ${WEDDING_CONFIG.bride.firstName}*
📅 Jumat, 28 Agustus 2026
📍 ${WEDDING_CONFIG.events[0].venue}

Detail lengkap & RSVP di:
${inviteLink}

Kami sangat berharap atas kehadiran & doa restu Anda 🤍`;
    window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, "_blank");
  };

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      toast.success("Link disalin");
    } catch {
      toast.error("Gagal menyalin");
    }
  };

  return (
    <>
      <motion.button
        data-testid="share-toggle"
        onClick={() => setOpen(true)}
        aria-label="Bagikan undangan"
        className="fixed bottom-6 left-6 z-40 w-14 h-14 rounded-full bg-ivory/80 backdrop-blur-md flex items-center justify-center audio-glow"
        initial={{ opacity: 0, scale: 0 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4, duration: 0.5 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.92 }}
      >
        <Share2 size={20} className="text-gold-dark" />
      </motion.button>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-charcoal/40 backdrop-blur-sm"
            onClick={() => setOpen(false)}
          >
            <motion.div
              initial={{ scale: 0.9, y: 20 }}
              animate={{ scale: 1, y: 0 }}
              exit={{ scale: 0.9, y: 20 }}
              className="bg-ivory border border-gold/30 p-6 md:p-8 w-full max-w-md relative"
              onClick={(e) => e.stopPropagation()}
              data-testid="share-modal"
            >
              <button
                onClick={() => setOpen(false)}
                className="absolute top-3 right-3 text-charcoal/60 hover:text-charcoal"
                aria-label="Tutup"
              >
                <X size={20} />
              </button>

              <p className="text-xs tracking-[0.3em] uppercase text-gold mb-2">Bagikan Undangan</p>
              <h3 className="font-serif text-3xl text-charcoal mb-5">Kirim ke Tamu</h3>

              <label className="text-xs tracking-[0.25em] uppercase text-gold">Nama Tamu</label>
              <input
                data-testid="share-guest-input"
                className="input-elegant mb-4"
                placeholder="Contoh: Bapak Budi Santoso"
                value={guestInput}
                onChange={(e) => setGuestInput(e.target.value)}
              />

              <p className="text-xs text-charcoal/60 mb-2">Link personal:</p>
              <div className="bg-white border border-gold/20 p-3 text-xs text-charcoal/80 font-mono break-all mb-5" data-testid="share-link-preview">
                {inviteLink}
              </div>

              <div className="flex gap-3">
                <button
                  onClick={shareWA}
                  data-testid="share-whatsapp"
                  className="flex-1 btn-gold inline-flex items-center justify-center gap-2"
                >
                  <MessageCircle size={16} /> WhatsApp
                </button>
                <button
                  onClick={copyLink}
                  data-testid="share-copy"
                  className="inline-flex items-center justify-center gap-2 border border-gold/40 px-5 py-2 text-xs tracking-[0.2em] uppercase text-gold hover:text-gold-dark"
                >
                  <Copy size={14} /> Salin
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
